export default "__VITE_ASSET__AzBsAaYm__"